export const convertNumberToString = (amount: number | string, maxDigit: number = 3) => {
  return Number(amount).toLocaleString('pl-PL', {
    maximumFractionDigits: 4,
  });
};
